














































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbCol, mdbInput, mdbRow, mdbTooltip } from '@folky-tools/mdbvue';
import {
    usersService,
    businessFrontPagesService,
    notificationsService,
    updateOrganizationBusinessOtherLinks,
    UpdateOrganizationBusinessOtherLinksDto,
    UpdateOrganizationBusinessOtherLinksLinkDto,
    getOrganizationBusinessExternalLinksById,
    businessesService
} from '@/services';
import { BusinessOpeningHours } from '@/models/businesses/business-opening-hours';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { Link, LinkType } from '@/models/common/link';
import { Business } from '@/models/businesses/business';

@Component({
    components: {
        mdbBtn,
        mdbCol,
        mdbInput,
        mdbRow,
        mdbTooltip,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        EditOtherLinks: () => import('@/components/shared/EditOtherLinks.vue'),
        EditCustomHighlights: () => import('@/components/businesses/EditCustomHighlights.vue'),
        EditOpeningHours: () => import('@/components/shared/EditOpeningHours.vue'),
        ExternalLinks: () => import('@/components/businesses/BusinessFrontPageExternalLinksSummaryCard.vue'),
        Images: () => import('@/components/businesses/BusinessFrontPageImagesSummaryCard.vue'),
        OpeningHours: () => import('@/components/businesses/BusinessFrontPageOpeningHoursSummaryCard.vue'),
        Titles: () => import('@/components/businesses/BusinessFrontPageTitlesSummaryCard.vue'),
        Slug: () => import('@/components/shared/SlugSummaryCard.vue'),
        ImagesAndTitles: () => import('@/components/businesses/BusinessFrontPageTitlesAndImage.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessFrontPageView extends Vue {
    private businessFrontPage: BusinessFrontPage = new BusinessFrontPage();
    private otherLinks: Link[] = [];
    private openingHours: BusinessOpeningHours = new BusinessOpeningHours();
    private business: Business = new Business();

    private showEditFrontPageOtherLinks: boolean = false;
    private showEditOpeningHours: boolean = false;

    private savingFrontPageOtherLinks: boolean = false;
    private savingOpeningHours: boolean = false;

    private pageContentLoaded: boolean = false;

    private showImageUploadPrompt: boolean = false;
    private showTimeTableMissingAlert: boolean = false;

    // #region GENERIC

    private async created(): Promise<void> {
        this.otherLinks = [];
        (await getOrganizationBusinessExternalLinksById.execute(+this.$route.params.id)).forEach(link => {
            if (link.type === LinkType.Other) {
                this.otherLinks.push(new Link(link));
            }
        });

        this.businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
        this.business = await businessesService.getBusiness(+this.$route.params.id);

        if (this.businessFrontPage.openingHours) {
            this.openingHours = this.businessFrontPage.openingHours.clone();
        }

        this.otherLinks = [];
        (await getOrganizationBusinessExternalLinksById.execute(+this.$route.params.id)).forEach(link => {
            if (link.type === LinkType.Other) {
                this.otherLinks.push(new Link(link));
            }
        });

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.Frontpage,
                entityId: +this.$route.params.id
            })
        );

        this.pageContentLoaded = true;
    }

    private async resetSlug(): Promise<void> {
        const businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
        this.businessFrontPage.slug = businessFrontPage.slug;
    }

    // #endregion GENERIC

    // #region EDIT OTHER LINKS

    private async saveFrontPageOtherLinks(): Promise<void> {
        this.showEditFrontPageOtherLinks = true;
        const editOtherLinksElement: any = this.$refs.editOtherLinks;

        try {
            const otherLinks = editOtherLinksElement.links.map((l: any) => new UpdateOrganizationBusinessOtherLinksLinkDto(l.title, l.url, l.type));
            await updateOrganizationBusinessOtherLinks.execute(new UpdateOrganizationBusinessOtherLinksDto(+this.$route.params.id, otherLinks));
            this.closeFrontPageOtherLinksEdition();

            notificationsService.showToastSuccessNotification('views.businesses.businessFrontPageView.notifications.additionalLinksUpdated');

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasChanged,
                    entity: UserActionEntityType.Businesses,
                    scope: UserActionScopeType.OtherLinks,
                    entityId: +this.$route.params.id
                })
            );
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageOtherLinks = false;
        }
    }

    private async closeFrontPageOtherLinksEdition(): Promise<void> {
        this.showEditFrontPageOtherLinks = false;
        this.otherLinks = [];
        (await getOrganizationBusinessExternalLinksById.execute(+this.$route.params.id)).forEach(link => {
            if (link.type === LinkType.Other) {
                this.otherLinks.push(new Link(link));
            }
        });
    }

    // #endregion EDIT OTHER LINKS

    // #region EDIT OPENING HOURS

    private editBusinessOpeningHours(): void {
        this.showEditOpeningHours = true;
    }

    private async saveBusinessOpeningHours(): Promise<void> {
        this.savingOpeningHours = true;

        try {
            if (await businessFrontPagesService.updateBusinessFrontPageOpeningHours(+this.$route.params.id, this.openingHours)) {
                this.businessFrontPage.openingHours = this.openingHours.clone();
                this.closeBusinessOpeningHours();

                notificationsService.showToastSuccessNotification('views.businesses.businessFrontPageView.notifications.openingHoursUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.OpeningHours,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingOpeningHours = false;
        }
    }

    private closeBusinessOpeningHours(): void {
        this.openingHours = this.businessFrontPage.openingHours.clone();
        this.showEditOpeningHours = false;
    }

    // #endregion EDIT OPENING HOURS
}
